import {
  getGTMImageDescription,
  getImageNameFromUrl,
} from '@/common/analytics/gtm/shared/analyticsEventsComposers';
import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';
import { HomepageCurrentEvent } from 'generatedBfw/static';

export const createCurrentEvent = (
  event: HomepageCurrentEvent,
  index: number,
): DefaultTrackPromotionEvent => {
  const imgDesc = getGTMImageDescription();
  return {
    promotion_id: `current_event|${HomepageConfig.analyticsGaName}|${event.id}`,
    promotion_name: `${event.title}|${event.author ? event.author.name : 'NA'}`,
    promotion_type: 'current_event',
    creative_name: getImageNameFromUrl(event.files.desktopStandard),
    creative_slot: `current_event|${index + 1}`,
    creative_size: imgDesc,
  };
};
